import { createRecipe } from '../__generated/implementation.js';
import { BurnerBaseW24Variant, FuelType, GrillBaseVariant, Handing, LynxProfessionalGrillVariant, LynxSedonaGrillVariant } from '../__generated/model/index.js';
import { CabinetWidth } from '../implementations/common.js';
import { getResourceUrlHack } from '../util/resources.js';
export const recipes = {
    drawer33Door66: [
        {
            title: '1/3 Drawer, 2/3 Door Base 18"',
            description: 'LYNX-2DDH-18',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/1-3-drawer-2-3-door.png'),
            recipes: [
                createRecipe({
                    type: 'Drawer33Door66',
                    width: CabinetWidth.W18,
                    handing: Handing.left,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '1/3 Drawer, 2/3 Door Base 24"',
            description: 'LYNX-2DDH-24',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/1-3-drawer-2-3-door.png'),
            recipes: [
                createRecipe({
                    type: 'Drawer33Door66',
                    width: CabinetWidth.W24,
                    handing: Handing.left,
                    wallId: 'Wall-1'
                })
            ]
        }
    ],
    endPanels: [
        {
            title: 'End Panel',
            description: 'LYNX-P-RSE-FEP',
            recipes: [
                createRecipe({
                    type: 'EndPanel',
                    wallId: 'Wall-1'
                })
            ]
        }
    ],
    fillers: [
        {
            title: '1"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-1.00',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W1,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '1.25"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-1.25',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W1_25,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '1.5"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-1.50',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W1_5,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '1.75"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-1.75',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W1_75,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '2"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-2.00',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W2,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '2.25"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-2.25',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W2_25,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '2.5"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-2.50',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W2_5,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '2.75"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-2.75',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W2_75,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '3"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-3.00',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W3,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '3.25"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-3.25',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W3_25,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '3.5"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-3.50',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W3_5,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '3.75"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-3.75',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W3_75,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '4"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-4.00',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W4,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '4.25"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-4.25',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W4_25,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '4.5"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-4.50',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W4_5,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '4.75"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-4.75',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W4_75,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '5"W Filler Panel',
            description: 'LYNX-P-RSE-FIL-5.00',
            recipes: [
                createRecipe({
                    type: 'Filler',
                    width: CabinetWidth.W5,
                    wallId: 'Wall-1'
                })
            ]
        }
    ],
    fullDoorBase: [
        {
            title: 'Full Door Base 12"',
            description: 'LYNX-FDH-12',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-base.png'),
            recipes: [
                createRecipe({
                    type: 'FullDoorBase',
                    width: CabinetWidth.W12,
                    handing: Handing.left,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: 'Full Door Base 18"',
            description: 'LYNX-FDH-18',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-base.png'),
            recipes: [
                createRecipe({
                    type: 'FullDoorBase',
                    width: CabinetWidth.W18,
                    handing: Handing.left,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: 'Full Door Base 24"',
            description: 'LYNX-FDH-24',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/full-door-base.png'),
            recipes: [
                createRecipe({
                    type: 'FullDoorBase',
                    width: CabinetWidth.W24,
                    handing: Handing.left,
                    wallId: 'Wall-1'
                })
            ]
        }
    ],
    sinkBaseCabinetRecipes: [
        {
            title: 'Full Door Sink Base 24"',
            description: 'LYNX-SBFDH-24',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/sink-base.png'),
            recipes: [
                createRecipe({
                    type: 'SinkBase',
                    width: CabinetWidth.W24,
                    handing: Handing.left,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: 'Full Door Sink Base 36"',
            description: 'LYNX-SBFD-36',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/sink-base.png'),
            recipes: [
                createRecipe({
                    type: 'SinkBase',
                    width: CabinetWidth.W36,
                    handing: Handing.both,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: 'Full Door Sink Base 48"',
            description: 'LYNX-SBFD-48',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/sink-base.png'),
            recipes: [
                createRecipe({
                    type: 'SinkBase',
                    width: CabinetWidth.W48,
                    handing: Handing.both,
                    wallId: 'Wall-1'
                })
            ]
        }
    ],
    threeDrawerBase: [
        {
            title: '3-Drawer Base 18"',
            description: 'LYNX-3D-18',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/3-drawer-base.png'),
            recipes: [
                createRecipe({
                    type: 'ThreeDrawerBase',
                    width: CabinetWidth.W18,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '3-Drawer Base 24"',
            description: 'LYNX-3D-24',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/3-drawer-base.png'),
            recipes: [
                createRecipe({
                    type: 'ThreeDrawerBase',
                    width: CabinetWidth.W24,
                    wallId: 'Wall-1'
                })
            ]
        }
    ],
    trashPulloutBase: [
        {
            title: 'Full Door Trash Pullout Base 18"',
            description: 'LYNX-PO-18',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/trash-pullout-base.png'),
            recipes: [
                createRecipe({
                    type: 'TrashPulloutBase',
                    width: CabinetWidth.W18,
                    handing: Handing.top,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: 'Full Door Trash Pullout Base 24"',
            description: 'LYNX-PO-24',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/trash-pullout-base.png'),
            recipes: [
                createRecipe({
                    type: 'TrashPulloutBase',
                    width: CabinetWidth.W24,
                    handing: Handing.top,
                    wallId: 'Wall-1'
                })
            ]
        }
    ],
    lynxProfessionalBurner: (fuelType)=>// TODO: Move te definition to data/appliances.ts and check available fuel types here.
        // Burners support Natural Gas and Propane:
        fuelType === FuelType.None ? [] : [
            {
                title: 'Single Side Burner',
                description: 'LSB1-3',
                // thumbnailUrl: getThumbnailUrlHack('/images/product-images/thumbnails/burner-base.png'),
                recipes: [
                    createRecipe({
                        type: 'BurnerBaseW24',
                        applianceId: 'LynxProfessionalSingleBurner-1',
                        handing: Handing.left,
                        variant: BurnerBaseW24Variant.CounterTopHeight,
                        wallId: 'Wall-1'
                    }),
                    createRecipe({
                        id: 'LynxProfessionalSingleBurner-1',
                        type: 'LynxProfessionalSingleBurner',
                        powderCoating: false
                    })
                ]
            },
            {
                title: 'Double Side Burner',
                description: 'LSB2-2',
                // thumbnailUrl: getThumbnailUrlHack('/images/product-images/thumbnails/burner-base.png'),
                recipes: [
                    createRecipe({
                        type: 'BurnerBaseW24',
                        applianceId: 'LynxProfessionalDoubleBurner-1',
                        handing: Handing.left,
                        variant: BurnerBaseW24Variant.CounterTopHeight,
                        wallId: 'Wall-1'
                    }),
                    createRecipe({
                        id: 'LynxProfessionalDoubleBurner-1',
                        type: 'LynxProfessionalDoubleBurner',
                        powderCoating: false
                    })
                ]
            },
            {
                title: 'Power Burner',
                description: 'LPB',
                // thumbnailUrl: getThumbnailUrlHack('/images/product-images/thumbnails/burner-base.png'),
                recipes: [
                    createRecipe({
                        type: 'BurnerBaseW24',
                        applianceId: 'LynxProfessionalPowerBurner-1',
                        variant: BurnerBaseW24Variant.Lowered,
                        handing: Handing.top,
                        wallId: 'Wall-1'
                    }),
                    createRecipe({
                        id: 'LynxProfessionalPowerBurner-1',
                        type: 'LynxProfessionalPowerBurner',
                        powderCoating: false
                    })
                ]
            }
        ],
    lynxProfessionalGrill: (fuelType)=>// TODO: Move te definition to data/appliances.ts and check available fuel types here.
        // Burners support Natural Gas and Propane:
        fuelType === FuelType.None ? [] : [
            {
                title: 'Lynx Professional Grill - 30"',
                description: '30" Professional Built-In Grill',
                thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/grill-base.png'),
                recipes: [
                    createRecipe({
                        type: 'GrillBase',
                        width: CabinetWidth.W36,
                        handing: Handing.both,
                        variant: GrillBaseVariant.Default,
                        applianceId: 'LynxProfessionalGrillW30-1',
                        wallId: 'Wall-1'
                    }),
                    createRecipe({
                        id: 'LynxProfessionalGrillW30-1',
                        type: 'LynxProfessionalGrillW30',
                        variant: LynxProfessionalGrillVariant.AllTrident,
                        powderCoating: false
                    })
                ]
            },
            {
                title: 'Lynx Professional Grill - 36"',
                description: '36" Professional Built-In Grill',
                thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/grill-base.png'),
                recipes: [
                    createRecipe({
                        type: 'GrillBase',
                        handing: Handing.both,
                        width: CabinetWidth.W42,
                        variant: GrillBaseVariant.Default,
                        applianceId: 'LynxProfessionalGrillW36-1',
                        wallId: 'Wall-1'
                    }),
                    createRecipe({
                        id: 'LynxProfessionalGrillW36-1',
                        type: 'LynxProfessionalGrillW36',
                        variant: LynxProfessionalGrillVariant.AllTrident,
                        powderCoating: false
                    })
                ]
            },
            {
                title: 'Lynx Professional Grill - 42"',
                description: '42" Professional Built-In Grill',
                thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/grill-base.png'),
                recipes: [
                    createRecipe({
                        type: 'GrillBase',
                        handing: Handing.both,
                        width: CabinetWidth.W48,
                        variant: GrillBaseVariant.Default,
                        applianceId: 'LynxProfessionalGrillW42-1',
                        wallId: 'Wall-1'
                    }),
                    createRecipe({
                        id: 'LynxProfessionalGrillW42-1',
                        type: 'LynxProfessionalGrillW42',
                        variant: LynxProfessionalGrillVariant.AllTrident,
                        powderCoating: false
                    })
                ]
            },
            {
                title: 'Lynx Professional Grill - 54"',
                description: '54" Professional Built-In Grill',
                thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/grill-base.png'),
                recipes: [
                    createRecipe({
                        type: 'GrillBase',
                        handing: Handing.both,
                        width: CabinetWidth.W60,
                        variant: GrillBaseVariant.Default,
                        applianceId: 'LynxProfessionalGrillW54-1',
                        wallId: 'Wall-1'
                    }),
                    createRecipe({
                        id: 'LynxProfessionalGrillW54-1',
                        type: 'LynxProfessionalGrillW54',
                        variant: LynxProfessionalGrillVariant.TridentAndRotisserie,
                        powderCoating: false
                    })
                ]
            }
        ],
    lynxSedonaGrill: (fuelType)=>// TODO: Move te definition to data/appliances.ts and check available fuel types here.
        // Burners support Natural Gas and Propane:
        fuelType === FuelType.None ? [] : [
            {
                title: 'Lynx Sedona Grill - 30"',
                description: '30" Sedona Built-In Grill',
                thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/grill-base.png'),
                recipes: [
                    createRecipe({
                        type: 'GrillBase',
                        handing: Handing.both,
                        width: CabinetWidth.W36,
                        variant: GrillBaseVariant.Default,
                        applianceId: 'LynxSedonaGrillW30-1',
                        wallId: 'Wall-1'
                    }),
                    createRecipe({
                        id: 'LynxSedonaGrillW30-1',
                        type: 'LynxSedonaGrillW30',
                        variant: LynxSedonaGrillVariant.ProSear_SsBurner1
                    })
                ]
            },
            {
                title: 'Lynx Sedona Grill - 36"',
                description: '36" Sedona Built-In Grill',
                thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/grill-base.png'),
                recipes: [
                    createRecipe({
                        type: 'GrillBase',
                        handing: Handing.both,
                        width: CabinetWidth.W42,
                        variant: GrillBaseVariant.Default,
                        applianceId: 'LynxSedonaGrillW36-1',
                        wallId: 'Wall-1'
                    }),
                    createRecipe({
                        id: 'LynxSedonaGrillW36-1',
                        type: 'LynxSedonaGrillW36',
                        variant: LynxSedonaGrillVariant.SsBurner3
                    })
                ]
            },
            {
                title: 'Lynx Sedona Grill - 42"',
                description: '42" Sedona Built-In Grill',
                thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/grill-base.png'),
                recipes: [
                    createRecipe({
                        type: 'GrillBase',
                        handing: Handing.both,
                        width: CabinetWidth.W48,
                        variant: GrillBaseVariant.Default,
                        applianceId: 'LynxSedonaGrillW42-1',
                        wallId: 'Wall-1'
                    }),
                    createRecipe({
                        id: 'LynxSedonaGrillW42-1',
                        type: 'LynxSedonaGrillW42',
                        variant: LynxSedonaGrillVariant.SsBurner3
                    })
                ]
            }
        ],
    lynxSedonaBurner: (fuelType)=>// TODO: Move te definition to data/appliances.ts and check available fuel types here.
        // Burners support Natural Gas and Propane:
        fuelType === FuelType.None ? [] : [
            {
                title: 'Single Side Burner',
                description: 'LSB501',
                // thumbnailUrl: getThumbnailUrlHack('/images/product-images/thumbnails/burner-base.png'),
                recipes: [
                    createRecipe({
                        type: 'FullDoorBase',
                        width: CabinetWidth.W24,
                        applianceId: 'LynxSedonaSingleBurner-1',
                        handing: Handing.left,
                        wallId: 'Wall-1'
                    }),
                    createRecipe({
                        id: 'LynxSedonaSingleBurner-1',
                        type: 'LynxSedonaSingleBurner',
                        powderCoating: false
                    })
                ]
            },
            {
                title: 'Double Side Burner',
                description: 'LSB502',
                // thumbnailUrl: getThumbnailUrlHack('/images/product-images/thumbnails/burner-base.png'),
                recipes: [
                    createRecipe({
                        type: 'FullDoorBase',
                        width: CabinetWidth.W24,
                        applianceId: 'LynxSedonaDoubleBurner-1',
                        handing: Handing.left,
                        wallId: 'Wall-1'
                    }),
                    createRecipe({
                        id: 'LynxSedonaDoubleBurner-1',
                        type: 'LynxSedonaDoubleBurner',
                        powderCoating: false
                    })
                ]
            }
        ],
    lynxSink: [
        {
            title: 'Lynx Professional Sink - 18"',
            description: 'LSK18',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/sink.png'),
            recipes: [
                createRecipe({
                    type: 'LynxSinkBase',
                    width: CabinetWidth.W24,
                    applianceId: 'LynxSinkW18-1',
                    handing: Handing.left,
                    wallId: 'Wall-1'
                }),
                createRecipe({
                    id: 'LynxSinkW18-1',
                    type: 'LynxSinkW18',
                    width: CabinetWidth.W18
                })
            ]
        },
        {
            title: 'Lynx Professional Sink - 24"',
            description: 'LSK24',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/sink.png'),
            recipes: [
                createRecipe({
                    type: 'LynxSinkBase',
                    width: CabinetWidth.W30,
                    applianceId: 'LynxSinkW24-1',
                    handing: Handing.both,
                    wallId: 'Wall-1'
                }),
                createRecipe({
                    id: 'LynxSinkW24-1',
                    type: 'LynxSinkW24',
                    width: CabinetWidth.W24
                })
            ]
        },
        {
            title: 'Lynx Professional Sink - 30"',
            description: 'LSK30',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/sink.png'),
            recipes: [
                createRecipe({
                    type: 'LynxSinkBase',
                    width: CabinetWidth.W36,
                    applianceId: 'LynxSinkW30-1',
                    handing: Handing.both,
                    wallId: 'Wall-1'
                }),
                createRecipe({
                    id: 'LynxSinkW30-1',
                    type: 'LynxSinkW30',
                    width: CabinetWidth.W30
                })
            ]
        },
        {
            title: 'Lynx Professional Built-In Cocktail Station',
            description: 'LCS30',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/cocktail-station.png'),
            recipes: [
                createRecipe({
                    type: 'LynxSinkBase',
                    width: CabinetWidth.W36,
                    applianceId: 'LynxProfessionalCocktailStation-1',
                    handing: Handing.both,
                    wallId: 'Wall-1'
                }),
                createRecipe({
                    id: 'LynxProfessionalCocktailStation-1',
                    type: 'LynxProfessionalCocktailStation'
                })
            ]
        }
    ],
    lynxEvo: (fuelType)=>// TODO: Move te definition to data/appliances.ts and check available fuel types here.
        // Burners support Natural Gas and Propane:
        fuelType === FuelType.None ? [] : [
            {
                title: 'EVO Affinity 25G',
                description: '10-0095',
                thumbnailUrl: '/images/product-images/thumbnails/evo-base.png',
                recipes: [
                    createRecipe({
                        type: 'EvoBaseW36',
                        handing: Handing.both,
                        applianceId: 'EvoAffinity25G-1',
                        wallId: 'Wall-1'
                    }),
                    createRecipe({
                        id: 'EvoAffinity25G-1',
                        type: 'EvoAffinity25G'
                    })
                ]
            }
        ],
    otherCookingItems: (fuelType)=>// TODO: Move te definition to data/appliances.ts and check available fuel types here.
        // Burners support Natural Gas and Propane:
        [
            ...fuelType !== FuelType.None ? [
                {
                    title: 'Lynx Asado - Flat Top Griddle',
                    description: 'L30AG',
                    thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/ceramic-grill-base.png'),
                    recipes: [
                        createRecipe({
                            type: 'GrillBase',
                            handing: Handing.both,
                            width: CabinetWidth.W36,
                            variant: GrillBaseVariant.Default,
                            applianceId: 'LynxAsadoGriddgle-1',
                            wallId: 'Wall-1'
                        }),
                        createRecipe({
                            id: 'LynxAsadoGriddgle-1',
                            type: 'LynxAsadoGriddgle',
                            powderCoating: false
                        })
                    ]
                }
            ] : [],
            {
                title: 'Lynx Kamado Grill',
                description: 'LCGR',
                recipes: [
                    createRecipe({
                        type: 'KamadoGrillBase',
                        handing: Handing.top,
                        applianceId: 'LynxKamadoGrill-1',
                        wallId: 'Wall-1'
                    }),
                    createRecipe({
                        id: 'LynxKamadoGrill-1',
                        type: 'LynxKamadoGrill'
                    })
                ]
            },
            {
                title: 'Napoli Pizza Oven',
                description: 'LPZA',
                recipes: [
                    createRecipe({
                        id: 'LynxNapoliPizzaOven-1',
                        type: 'LynxNapoliPizzaOven',
                        wallId: 'Wall-1'
                    })
                ]
            }
        ],
    lynxSedonaHood: [
        {
            title: 'Lynx Sedona Vent Hood 36"',
            description: 'SVH36',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/lynx-pro-36-vent-hood.png'),
            recipes: [
                createRecipe({
                    type: 'LynxSedonaHoodW36',
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: 'Lynx Sedona Vent Hood 42"',
            description: 'SVH42',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/lynx-pro-42-vent-hood.png'),
            recipes: [
                createRecipe({
                    type: 'LynxSedonaHoodW42',
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: 'Lynx Sedona Vent Hood 48"',
            description: 'SVH48',
            thumbnailUrl: getResourceUrlHack('/images/product-images/thumbnails/lynx-pro-48-vent-hood.png'),
            recipes: [
                createRecipe({
                    type: 'LynxSedonaHoodW48',
                    wallId: 'Wall-1'
                })
            ]
        }
    ],
    refrigerationRecipes: [
        {
            title: '24" Professional Outdoor Beverage Dispenser',
            description: 'LN24BF1',
            recipes: [
                createRecipe({
                    type: 'LynxProfessionalOutdoorBeverageDispenserW24',
                    handing: Handing.left,
                    wallId: 'Wall-1',
                    towerKitId: 'LynxProfessionalSingleTapTowerKit-1'
                }),
                createRecipe({
                    type: 'LynxProfessionalSingleTapTowerKit'
                })
            ]
        },
        {
            title: '24" Professional Refrigerator Freezer Combo',
            description: 'LN24REFC',
            recipes: [
                createRecipe({
                    type: 'LynxProfessionalRefrigeratorFreezerComboW24',
                    handing: Handing.left,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '24" Professional Outdoor Refrigerator',
            description: 'LN24REF',
            recipes: [
                createRecipe({
                    type: 'LynxProfessionalOutdoorRefrigeratorW24',
                    handing: Handing.left,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '24" Professional Outdoor Refrigerator with Glass Door',
            description: 'LN24REFG',
            recipes: [
                createRecipe({
                    type: 'LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24',
                    handing: Handing.left,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '24" Professional Two Drawer Refrigerator',
            description: 'LN24DWR',
            recipes: [
                createRecipe({
                    type: 'LynxProfessionalTwoDrawerRefrigeratorW24',
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '15" Professional Refrigerator',
            description: 'LN15REF',
            recipes: [
                createRecipe({
                    type: 'LynxProfessionalRefrigeratorW15',
                    handing: Handing.left,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '15" Professional Wine Cellar',
            description: 'LN15WINE',
            recipes: [
                createRecipe({
                    type: 'LynxProfessionalWineCellarW15',
                    handing: Handing.left,
                    wallId: 'Wall-1'
                })
            ]
        },
        {
            title: '15" Professional Outdoor Ice Machine',
            description: 'LN15ICE',
            recipes: [
                createRecipe({
                    type: 'LynxProfessionalOutdoorIceMachineW15',
                    handing: Handing.left,
                    wallId: 'Wall-1',
                    drainPumpId: 'LynxProfessionalOutdoorIceMachineDrainPump-1'
                }),
                createRecipe({
                    id: 'LynxProfessionalOutdoorIceMachineDrainPump-1',
                    type: 'LynxProfessionalOutdoorIceMachineDrainPump'
                })
            ]
        }
    ]
};

//# sourceMappingURL=recipes.js.map